import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthBaseQuery } from './baseQuery';

export const supplyChainApi = createApi({
  reducerPath: 'supplyChainApi',
  baseQuery: createAuthBaseQuery(),
  tagTypes: ['SupplyChain'],
  endpoints: (builder) => ({
    getPurchaseOrders: builder.query<unknown[], void>({
      query: () => 'inventory/purchase-orders',
      providesTags: ['SupplyChain'],
    }),
    getSuppliers: builder.query<unknown[], void>({
      query: () => 'inventory/suppliers',
      providesTags: ['SupplyChain'],
    }),
  }),
});

export const { useGetPurchaseOrdersQuery, useGetSuppliersQuery } = supplyChainApi;
